import { AbstractControl } from '@angular/forms';

export const ctl = (_: AbstractControl | null) => _ as AbstractControl;
